import React from "react"

import { gql } from "@urql/core"

import { useQuery } from "hooks/urql"

import UrqlLoadingIndicator from "components/WithLoadingIndicator/urql"

import Form from "./Form"

const EditOrganization = ({ organizationId, ...rest }) => {
  const [result] = useQuery({
    query: organizationQuery,
    variables: { organizationId },
  })

  return (
    <UrqlLoadingIndicator result={result}>
      {({ data }) => <Form organization={data.organization} {...rest} />}
    </UrqlLoadingIndicator>
  )
}

const organizationQuery = gql`
  query AdminOrganizationFormEdit($organizationId: ID!) {
    organization(id: $organizationId) {
      id
      name
      slug
      emailTimeZone
      details
      calendarEmbedUrl
      lowBandwidthCloudroom
      disableRealtimeboardInvites
      disableStudentNotifications
      recordSessionAudio
      studentScreenShareDisabled
      billingEnabled
      paysByCheck
      hourlyRate
      allowLongSessions
      noShowRate
      allowLongNoShows
      perStudentConcurrentCourseLimit
      courseGroupLimit
      minimumGroupSize
      consecutiveNoShowThreshold
      addressLine
      attention
      intakeBlurb: rawIntakeBlurb
      simpleIntakeBlurb: rawSimpleIntakeBlurb
      minimumAvailabilityWindows
      allowedDomains
      intakeParentRequired
      stateAssignedUid
      cleverDistrictId
      classlinkDistrictId
      sessionTimeoutMinutes
      studentCamerasRequired
      reassignStudentsOnMissingTutor
      omitStatementBalance
      slackChannelId
      minTutorConsistencyRate
      participationDigestEnabled
      participationDigestRecipients
      zipCodesForDisplay
      tutorsCanRequestReplacements
      sftpTo

      address {
        country
        region
      }

      primaryAdmin {
        id
        email
      }
    }
  }
`

export default EditOrganization
